import { PencilIcon, XIcon } from '@heroicons/react/solid';

interface UploadedImageCardProps {
  imageUrl: string;
  label: string;
  onDelete: () => void;
  onEdit?: () => void;
}

export default function UploadedImageCard({
  imageUrl,
  label,
  onDelete,
  onEdit,
}: UploadedImageCardProps) {
  return (
    <div className='group relative aspect-square min-w-[88px] overflow-hidden rounded-2xl border-2 border-gray-300 bg-white dark:border-slate-600 dark:bg-slate-800'>
      <img
        src={imageUrl}
        alt={label}
        loading='lazy'
        className='absolute inset-0 h-full w-full object-cover'
      />
      <div className='absolute right-1.5 top-1.5 flex items-center gap-1'>
        {onEdit && (
          <button
            type='button'
            onClick={onEdit}
            aria-label={`Edit ${label}`}
            title='Edit image'
            className='flex h-7 w-7 items-center justify-center rounded-full bg-black/60 text-white transition hover:bg-black/80'
          >
            <PencilIcon className='h-4 w-4' />
          </button>
        )}
        <button
          type='button'
          onClick={onDelete}
          aria-label={`Remove ${label}`}
          className='flex h-7 w-7 items-center justify-center rounded-full bg-black/60 text-white transition hover:bg-black/80'
        >
          <XIcon className='h-4 w-4' />
        </button>
      </div>
      <div className='absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 via-black/40 to-transparent px-2 pb-1.5 pt-5'>
        <p className='text-center text-[11px] font-medium text-white'>
          {label}
        </p>
      </div>
    </div>
  );
}
